import styled from "styled-components"

import {
  BodyBold,
  SmallText,
} from "ggx-componentlibrary/design/typography/typography.styles"

import { SPACING } from "../../../../../component-library/design/spacing/spacing.constants"
import { COLOR } from "../../../../../component-library/design/color/color.constants"
import { TextField } from "../../../../../component-library/components/text-field/text-field.component"

const PackageSizeGrid = styled.div`
  display: grid;
  width: calc(100% - 48px);
  grid-row-gap: ${SPACING.XS};
  grid-column-gap: 16px;
  grid-template-rows: auto;
  grid-template-columns: repeat(3, 33.33%);
`

const ColumnHeading = styled(BodyBold)``

const InformationContainer = styled.div`
  margin-top: ${({ addExtraMargin }) =>
    addExtraMargin ? SPACING.M : SPACING.XS};
  display: flex;
  flex-direction: column;
  template-rows: auto;
  column-gap: 16px;
  template-columns: calc(75% - 36px + 32px) calc(25% - 12px);
`

const Information = styled(SmallText)`
  margin-bottom: 0;
`

const StyledTextField = styled(TextField)`
  & input {
    width: 100%;
  }
`

const PackageSizeError = styled(SmallText)`
  color: ${COLOR.RED_MEDIUM};
`

const StyledWrapper = styled.div`
  position: relative;
`

const Options = styled.div`
  display: grid;
  grid-gap: 16px;
  grid-template-rows: auto;
  grid-template-columns: repeat(3, 180px);
  margin-bottom: ${SPACING.M};
`
const Option = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  padding: 12px;
  border: 1px solid ${({ selected }) => selected ? COLOR.BLUE_MEDIUM : COLOR.GREY_LIGHT};
  > p { color: ${({ selected }) => selected ? COLOR.BLUE_MEDIUM : COLOR.BLACK}; }
  font-weight: ${({ selected }) => selected ? 700 : 400};
  cursor: pointer;
  &:hover {
    border: 1px solid ${COLOR.BLUE_MEDIUM};
  }
`

export {
  PackageSizeGrid,
  ColumnHeading,
  StyledTextField,
  PackageSizeError,
  StyledWrapper,
  Information,
  InformationContainer,
  Options,
  Option,
}
